import React from "react";
import PropTypes from "prop-types";
import {
  Container,
  Title,
  SettingsGrid,
  SettingCard,
  CardIcon,
  CardTitle,
  CardDescription,
  CardButton,
  UserInfoSection,
  UserInfoTitle,
  UserInfoIcon,
  UserInfoGrid,
  UserInfoItem,
  UserInfoLabel,
  UserInfoValue,
  DisabledCard,
  SignatureStatusText,
} from "./home.styled";
import { useTranslation } from "react-i18next";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";
import * as ViewerService from "./../../../services/ViewerService";
import * as CenterService from "./../../../services/CenterService";
import moment from "moment-timezone";

const HomeSettingView = ({
  userInfo,
  onChangePassword,
  onDigitalSignature,
  onPersonalData,
  onNotificationSettings,
  onSecuritySettings,
  onThemeSettings,
  role,
  canSyncroData,
  onLOPDModal,
}) => {
  const { t } = useTranslation();

  const sincronizeUsers = async () => {
    try {
      let result = await ViewerService.synchDataViewers();

      let title = "";
      let text = "";
      let icon = "";
      if (result) {
        title = t("forms.center.messages.synchronize.titleViewers");
        text = t("forms.center.messages.synchronize.success");
        icon = "success";
      } else {
        title = "Error";
        text = t("forms.center.messages.synchronize.error");
        icon = "error";
      }

      let okAction = () => {};
      ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const sincronizeFarms = async () => {
    try {
      let result = await CenterService.synchDataFarms();

      let title = "";
      let text = "";
      let icon = "";
      if (result) {
        title = t("forms.center.messages.synchronize.title");
        text = t("forms.center.messages.synchronize.success");
        icon = "success";
      } else {
        title = "Error";
        text = t("forms.center.messages.synchronize.error");
        icon = "error";
      }

      let okAction = () => {};
      ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
    } catch (error) {
      //console.log('Error', error);
    }
  };

  return (
    <Container>
      <Title>{t("forms.settings.title")}</Title>

      {/* Información del Usuario */}
      <UserInfoSection>
        <UserInfoTitle>
          <UserInfoIcon className="fa-solid fa-user" />
          {t("forms.settings.userInfo.title")}
        </UserInfoTitle>
        <UserInfoGrid>
          <UserInfoItem>
            <UserInfoLabel>
              {t("forms.settings.userInfo.labels.name")}
            </UserInfoLabel>
            <UserInfoValue>{userInfo.name}</UserInfoValue>
          </UserInfoItem>
          <UserInfoItem>
            <UserInfoLabel>
              {t("forms.settings.userInfo.labels.email")}
            </UserInfoLabel>
            <UserInfoValue>{userInfo.email}</UserInfoValue>
          </UserInfoItem>
        </UserInfoGrid>
      </UserInfoSection>

      {/* Configuraciones Disponibles */}
      <SettingsGrid>
        {/* sincronizar usuarios */}
        <SettingCard>
          <CardIcon>
            <i className="fa-solid fa-users" />
          </CardIcon>
          <CardTitle>{t("forms.settings.syncEmployees.title")}</CardTitle>

          <CardDescription>
            <SignatureStatusText $isRegistered={true}>
              <i className="fa-solid fa-check-circle" />
              {t("forms.settings.syncEmployees.lastSync")}:{" "}
              {moment(canSyncroData.addViewerDate).format("DD/MM/YYYY") ||
                "N/A"}
            </SignatureStatusText>
          </CardDescription>

          <CardDescription>
            <p>{t("forms.settings.syncEmployees.description")}</p>
          </CardDescription>

          <CardButton onClick={sincronizeUsers}>
            {t("forms.settings.buttons.sync")}
          </CardButton>
        </SettingCard>

        {canSyncroData.canSyncro ? (
          <SettingCard onClick={onLOPDModal}>
            <CardIcon>
              <i className="fa-solid fa-building" />
            </CardIcon>
            <CardTitle>{t("forms.settings.syncFarms.title")}</CardTitle>

            <CardDescription>
              <SignatureStatusText $isRegistered={true}>
                <i className="fa-solid fa-check-circle" />
                {t("forms.settings.syncFarms.lastSync")}:{" "}
                {moment(canSyncroData.addFarmDate).format("DD/MM/YYYY") ||
                  "N/A"}
              </SignatureStatusText>
            </CardDescription>
            <CardDescription>
              {t("forms.settings.syncFarms.description")}
            </CardDescription>

            <CardButton onClick={sincronizeFarms}>
              {t("forms.settings.buttons.sync")}
            </CardButton>
          </SettingCard>
        ) : (
          <DisabledCard>
            <CardIcon>
              <i className="fa-solid fa-users" />
            </CardIcon>
            <CardTitle>{t("forms.settings.syncFarms.title")}</CardTitle>
            <CardDescription>
              <SignatureStatusText $isRegistered={false}>
                <i className="fa-solid fa-triangle-exclamation" />
                {t("forms.settings.syncEmployees.title")}
              </SignatureStatusText>
            </CardDescription>
            <CardDescription>
              <p>{t("forms.settings.syncEmployees.warning")}</p>
            </CardDescription>
          </DisabledCard>
        )}
      </SettingsGrid>
    </Container>
  );
};

HomeSettingView.propTypes = {
  userInfo: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    roles: PropTypes.array,
    hasSignature: PropTypes.bool,
    lopd: PropTypes.bool,
  }),
  onChangePassword: PropTypes.func.isRequired,
  onDigitalSignature: PropTypes.func.isRequired,
  onPersonalData: PropTypes.func.isRequired,
  onNotificationSettings: PropTypes.func.isRequired,
  onSecuritySettings: PropTypes.func.isRequired,
  onThemeSettings: PropTypes.func.isRequired,
};

export default HomeSettingView;
